// AUTO-GENERATED by scripts/gen-build-info.js (npm prebuild hook). Do not edit by hand.
export const BUILD_INFO = {"commit":"98a29d1ca","time":"2026-11-05T15:56:53.465Z"} as const;
